<template>
  <div class="switch-setting-wrapper">
    <template v-for="setting in getElementSettings">
      <div
        v-if="isVisibleSwitch(setting.key)"
        :key="setting.key"
        class="switch-group"
      >
        <div class="switch-group-left">
          <img :src="setting.icon" alt="" height="17px" width="17px" />
          <label class="caption">{{ setting.label }}</label>
        </div>
        <CommonSwitch
          v-if="setting.key !== 'isOptionSize'"
          v-model="element.settings[setting.key]"
          :isDisabled="setting.isDisabled"
          @onChange="setting.change"
          class="large-size"
        />
        <OptionImagePositionSettings
          v-if="
            setting.key === 'isImageAdjust' && element.settings.isImageAdjust
          "
          :key="`position_${setting.key}`"
          :element="element"
          :isUserHasAccess="isUserHasAccess"
        />
        <OptionSizeSettings
          v-if="setting.key === 'isOptionSize'"
          :key="`size_${setting.key}`"
          :element="element"
          :isUserHasAccess="isUserHasAccess"
        />
        <OptionLinkSettings
          v-if="
            setting.key === 'isOptionLinked' && element.settings.isOptionLinked
          "
          :key="`link_${setting.key}`"
          :element="element"
          :isUserHasAccess="isUserHasAccess"
        />
      </div>
    </template>
  </div>
</template>

<script>
import CommonSwitch from '../widgets/CommonSwitch.vue';
import OptionSizeSettings from './sidebarEditorElements/OptionSizeSettings.vue';
import OptionImagePositionSettings from './sidebarEditorElements/OptionImagePositionSettings.vue';
import OptionLinkSettings from './sidebarEditorElements/OptionLinkSettings.vue';
export default {
  data() {
    return {};
  },
  props: {
    element: Object,
    isUserHasAccess: Boolean,
  },
  methods: {
    isVisibleSwitch(setting) {
      if (setting === 'hidden') {
        return !['hidden', 'audioinput'].includes(this.element.type);
      }
      if (setting === 'required') {
        return !['audioinput'].includes(this.element.type);
      }

      if (setting === 'prefilled') {
        return ['radio', 'toggleswitch'].includes(this.element.type);
      }

      if (setting === 'default') {
        return ![
          'file',
          'audioinput',
          'radio',
          'checkbox',
          'filenew',
        ].includes(
          this.element.type
        );
      }

      if (setting === 'disabled') {
        return !['audioinput'].includes(this.element.type);
      }

      if (
        [
          'isImgShowInBackGround',
          'isShowTitleAndDescription',
          'isImageAdjust',
          'isOptionSize',
          'isTextOutSide',
          'isOptionLinked',
        ].includes(setting)
      ) {
        return (
          ['radio', 'checkbox'].includes(this.element.type) &&
          this.element.settings.appearance === 'card'
        );
      }

      if (setting === 'searchEnabled') {
        return this.element.type === 'select';
      }

      if (setting === 'showVerticle') {
        return false;
        // use this when enabled
        // return (
        //   ['radio', 'checkbox'].includes(this.element.type) &&
        //   this.element?.settings?.appearance !== 'card' &&
        //   this.element?.settings?.appearance !== 'oval'
        // );
      }

      if (setting === 'todayAsDefaultValue') {
        return ['date', 'datetime-local', 'time'].includes(this.element.type);
      }

      if (setting === 'isHtmlRendered') {
        return this.element.type === 'html';
      }

      return false;
    },
    onChangeShowVertical(e) {
      this.$set(
        this.element.settings,
        'showVerticle',
        e?.target?.checked || false
      );
    },
    onChangeRequired() {
      if (this.element.type === 'checkbox') {
        if (this.element.settings.required) {
          this.element.settings.min = 1;
          this.element.settings.max = this.element.options.length;
        } else {
          this.element.settings.min = 0;
          this.element.settings.max = 0;
        }
      }
    },
    onChangeDefault() {
      if (
        this.isVisibleSwitch('todayAsDefault') &&
        this.element.settings.default
      ) {
        this.$set(this.element.settings, 'todayAsDefaultValue', false);
      }
    },
    onChangeTodayAsDefault() {
      if (this.element.settings.todayAsDefaultValue) {
        this.$set(this.element.settings, 'default', false);
      }
    },
    ensureHiddenSetting() {
      if (!this.element || !this.element.settings) return;
      if (
        !Object.prototype.hasOwnProperty.call(this.element.settings, 'hidden')
      ) {
        this.$set(this.element.settings, 'hidden', false);
      }
      if (
        this.element.type === 'toggleswitch' &&
        !Object.prototype.hasOwnProperty.call(
          this.element.settings,
          'prefilled'
        )
      ) {
        this.$set(this.element.settings, 'prefilled', true);
      }
    },
  },
  computed: {
    getElementSettings() {
      this.ensureHiddenSetting();
      return [
        {
          label: 'Feld Erforderlich',
          key: 'required',
          change: this.onChangeRequired,
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-required.svg'),
        },
        {
          label: 'Hidden',
          key: 'hidden',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/eye-icon.svg'),
        },
        {
          label: 'Vorfüllen',
          key: 'prefilled',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-prefill.svg'),
        },
        {
          label: 'Beispielwert als Standartwert verwenden',
          key: 'default',
          change: this.onChangeDefault,
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-prefill.svg'),
        },
        {
          label: 'Feld sperren',
          key: 'disabled',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-lock.svg'),
        },
        {
          label: 'Bild im Hintergrund',
          key: 'isImgShowInBackGround',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-background.svg'),
        },
        {
          label: 'Beschreibung hinzufügen',
          key: 'isShowTitleAndDescription',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-description.svg'),
        },
        {
          label: 'Suche aktivieren',
          key: 'searchEnabled',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-search.svg'),
        },
        {
          label: 'VertikalAnzeigen',
          key: 'showVerticle',
          change: this.onChangeShowVertical,
          isDisabled: !this.isUserHasAccess,
          icon: '',
        },

        {
          label: 'Heute als Standardwert',
          key: 'todayAsDefaultValue',
          change: this.onChangeTodayAsDefault,
          isDisabled: !this.isUserHasAccess,
          icon: '',
        },
        {
          label: 'HTML-Rendering',
          key: 'isHtmlRendered',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/work-flow-icons/preview.svg'),
        },
        {
          label: 'Title Außerhalb der Karte',
          key: 'isTextOutSide',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-text-oustside.svg'),
        },
        {
          label: 'Größe',
          key: 'isOptionSize',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-size.svg'),
        },
        {
          label: 'Bild Position anpassen',
          key: 'isImageAdjust',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-image-position.svg'),
        },
        {
          label: 'Taste/Link',
          key: 'isOptionLinked',
          change: () => {},
          isDisabled: !this.isUserHasAccess,
          icon: require('@/assets/img/form-settings-option-link.svg'),
        },
      ];
    },
  },
  components: {
    CommonSwitch,
    OptionSizeSettings,
    OptionImagePositionSettings,
    OptionLinkSettings,
  },
};
</script>

<style scoped>
.switch-setting-wrapper {
  display: flex;
  flex-direction: column;
  align-items: unset;
  justify-content: center;
}
.switch-setting-wrapper .switch-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 0.5px solid #d1d9e2;
  gap: 12px;
  min-height: 45px;
}

.switch-setting-wrapper:has(.size-settings-wrap) .switch-group {
  flex-flow: wrap;
  gap: 0px;
}

.switch-setting-wrapper .switch-group:first-child {
  border-top: 0.5px solid #d1d9e2;
}

.switch-setting-wrapper .switch-group:last-child {
  border: none;
}

.switch-setting-wrapper .switch-group .switch-group-left {
  display: flex;
  gap: 10px;
  align-items: center;
}
.switch-setting-wrapper .large-size {
  display: flex;
}
.switch-setting-wrapper .switch-group .caption {
  font-family: 'OpenSans-Regular';
  display: block;
  padding: 0;
  margin: 0;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  box-sizing: border-box;
  font-weight: 400;
  line-height: 17px;
}

.switch-setting-wrapper .switch-group ::v-deep .large-size {
  width: unset;
  height: unset;
  vertical-align: middle;
}
.switch-setting-wrapper .switch-group ::v-deep .large-size .toggle-switch {
  width: 40px;
  height: 23px;
}
.switch-setting-wrapper
  .switch-group
  ::v-deep
  .large-size
  .toggle-switch-slider:before {
  position: absolute;
  content: '';
  height: 19px;
  width: 19px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
}
.switch-setting-wrapper
  .switch-group
  ::v-deep
  .large-size
  .toggle-switch
  input:checked
  + .toggle-switch-slider:before {
  transform: translateX(18px);
}
</style>
